<template>
  <div class="login-bg">
    <div class="login-container">
      <div class="login-left">
        <div class="slogan">
          <div class="title-main">交易<br><span>高雅的艺术</span></div>
          <!-- <div class="desc">
            龟谷是一家以跨市场洞察驱动为核心的金融科技服务公司<br>
            通过国际化视野与多元化投资策略结合<br>
            为投资者提供专业、系统的课程及培训服务<br>
            助力个人和机构提升金融素养，实现财富管理的科学化、专业化和智能化
          </div> -->
          <div class="copyright">
            Copyright 2012--2025 whhgfx.com版权所有 黔ICP备2025056779号<br>
            黔ICP备2025056779号隐私声明资质证照网站支持IPv6
          </div>
        </div>
      </div>
      <div class="login-right">
        <div class="login-box">
          <div class="login-title">
            <img src="@/assets/logo.png" alt="logo" class="logo-img" />
            欢迎来到龟谷论坛
          </div>
          <div class="login-tabs">
            <span :class="{active: tab==='password'}" @click="tab='password'">密码登录</span>
<!--            <span :class="{active: tab==='code'}" @click="tab='code'">短信登录</span>-->
          </div>
          <div class="login-form">
            <template v-if="tab==='password'">
              <input class="input" type="text" placeholder="请输入账号" v-model="username" />
              <input class="input" type="password" placeholder="请输入密码" v-model="password" />
            </template>
<!--            <template v-else>
              <input class="input" type="text" placeholder="请输入手机号" v-model="phone" />
              <div style="display: flex; gap: 8px; align-items: center;">
                <input class="input" type="text" placeholder="请输入验证码" v-model="code" style="flex:1;" />
                <button class="login-btn" :disabled="smsTimer > 0 || !phone || !/^1[3-9]\d{9}$/.test(phone)" @click="sendSmsCode" style="width:120px; padding:0 8px; font-size:14px;">
                  {{ smsTimer > 0 ? `${smsTimer}s后重发` : '发送验证码' }}
                </button>
              </div>
            </template>-->
            <div class="form-row">
              <label class="checkbox">
                <input type="checkbox" v-model="checked" />
                <span>我已阅读并同意《用户协议》和《隐私政策》</span>
              </label>
            </div>
            <button class="login-btn" :disabled="!canLogin" @click="handleLogin">立即登录</button>
          </div>
          <div class="login-links">
            <router-link to="/register">注册账号</router-link>
<!--            <router-link to="/reset-password">找回密码</router-link>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineOptions } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { login, loginByCode } from '@/api/login'    //sendSmsApi
import { onUnmounted } from 'vue'
defineOptions({ name: 'LoginPage' })
import { useAuth } from '@/composables/useAuth'
//import { ElMessage } from 'element-plus'
const router = useRouter()
const route = useRoute()
const { loginUser } = useAuth()
const tab = ref('password')
const username = ref('')
const password = ref('')
const phone = ref('')
const code = ref('')
const checked = ref(false)
//const smsTimer = ref(0)
let smsInterval = null

const canLogin = computed(() => {
  if (tab.value === 'password') {
    return username.value && password.value && checked.value
  } else {
    return /^1[3-9]\d{9}$/.test(phone.value) && code.value && checked.value
  }
})

async function handleLogin() {
  if (!checked.value) {
    window.$message
      ? window.$message.warning('请先阅读并同意《用户协议》和《隐私政策》')
      : alert('请先阅读并同意《用户协议》和《隐私政策》');
    return;
  }

  let loginPromise
  if(tab.value === 'password'){
    loginPromise = login(username.value, password.value, '', '')
  } else {
    loginPromise = loginByCode(phone.value, code.value, '')
  }
console.log("..--->"+loginPromise.data)
  const success = await loginUser(loginPromise)
  if (success) {
    // 跳转逻辑
    const redirect = route.query.redirect

    if (redirect) {
      router.push(redirect)
    } else {
      router.push('/')
    }
    // 登录成功后保存
    localStorage.setItem('username', username.value);
  }
}

/*function sendSmsCode() {
  if (smsTimer.value > 0) return;
  if (!/^1[3-9]\d{9}$/.test(phone.value)) {
    window.$message ? window.$message.warning('请输入正确的手机号') : alert('请输入正确的手机号');
    return;
  }
  // 这里调用发送验证码的API
  sendSmsApi(phone.value).then((res) => {
    if (res.code === 200) {
      window.$message ? window.$message.success('验证码已发送') : ElMessage.success('验证码已发送');
    } else {
      window.$message ? window.$message.error(res.msg || '发送失败') : ElMessage.error(res.msg || '发送失败');
      return;
    }
    smsTimer.value = 60;
    smsInterval = setInterval(() => {
      smsTimer.value--;
      if (smsTimer.value <= 0) {
        clearInterval(smsInterval);
        smsInterval = null;
      }
    }, 1000);
  }).catch(err => {
    console.error('发送验证码失败:', err)
    window.$message ? window.$message.error('发送验证码失败，请稍后重试') : ElMessage.error('发送验证码失败，请稍后重试');
  })
}*/

// 页面卸载时清理定时器
onUnmounted(() => {
  if (smsInterval) clearInterval(smsInterval)
})
</script>

<style scoped>
.login-bg {
  min-height: 100vh;
  background: url('../assets/regist-login.png') no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-container {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-left {
  flex: 1.2;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 560px;
  height: 100vh;
}
.slogan {
  margin-right: 60px;
  max-width: 560px;
}
.title-main {
  text-align: left;
  font-size: 2.8rem;
  font-weight: 700;
  color: #258aff;
  line-height: 1.2;
  margin-bottom: 18px;
}
.title-main span {
  color: #258aff;
}
.desc {
  color: #444;
  text-align: left;
  font-size: 1.08rem;
  margin-bottom: 32px;
  line-height: 1.7;
}
.copyright {
  text-align: left;
  color: #bbb;
  font-size: 12px;
  margin-top: 40px;
}
.login-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 420px;
  height: 100vh;
}
.login-box {
  width: 380px;
  margin-left: 40px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 32px rgba(0,64,255,0.08);
  padding: 38px 36px 28px 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.login-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #222;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: center;
}
.logo-img {
  width: 40px;
  height: 40px;
  filter: brightness(0) saturate(100%) invert(27%) sepia(96%) saturate(7500%) hue-rotate(212deg) brightness(102%) contrast(101%);
  object-fit: contain;
}
.login-tabs {
  width: 100%;
  display: flex;
  border-bottom: 1.5px solid #e6e6e6;
  margin-bottom: 22px;
}
.login-tabs span {
  flex: 1;
  text-align: center;
  padding: 8px 0;
  font-size: 15px;
  color: #888;
  cursor: pointer;
  border-bottom: 2.5px solid transparent;
  transition: color 0.2s, border 0.2s;
}
.login-tabs .active {
  color: #258aff;
  border-bottom: 2.5px solid #258aff;
  font-weight: bold;
}
.login-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 10px;
}
.input {
  width: 100%;
  padding: 10px 12px;
  border: 1.2px solid #e6e6e6;
  border-radius: 6px;
  font-size: 15px;
  outline: none;
  transition: border 0.2s;
}
.input:focus {
  border: 1.2px solid #258aff;
}
.form-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.checkbox {
  font-size: 13px;
  color: #888;
  display: flex;
  align-items: center;
  gap: 4px;
}
.login-btn {
  width: 100%;
  background: #258aff;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 10px 0;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 6px;
  transition: background 0.2s;
}
.login-btn:disabled {
  background: #b3d6ff;
  cursor: not-allowed;
}
.login-links {
  width: 100%;
  text-align: center;
  margin-top: 12px;
  color: #888;
  font-size: 14px;
}
.login-links a, .login-links .router-link-active {
  color: #258aff;
  text-decoration: none;
  margin: 0 4px;
}
@media (max-width: 900px) {
  .login-left {
    display: none;
  }
  .login-right {
    flex: 1;
    justify-content: center;
    min-width: 0;
  }
  .login-box {
    margin: 0;
  }
}
@media (max-width: 500px) {
  .login-box {
    width: 98vw;
    padding: 18px 2vw 18px 2vw;
  }
}
</style> 